import { enhancedApi } from './codegen.api';

export const brandApi = enhancedApi.enhanceEndpoints({});

export const {
	useBrandsListQuery,
	useBrandsRetrieveQuery,
	useOffersRetrieveQuery,
	useLazyOffersRetrieveQuery,
	useOffersPostsSendToPmCreateMutation,
} = brandApi;
